import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home/index";
// import Article from "../views/Article/index";
// import ArticleDetail from "../views/Article/detail";
// import Nx from "../views/Nx/index";
import Customer from "../views/Customer/index";
import ProductCenter from "../views/ProductCenter/index";
import NewsUpdates from "../views/NewsUpdates/index";
import SetPrice from "../views/SetPrice/index";
import ContactUs from "../views/ContactUs/index";
import FreeTrial from "../views/FreeTrial/index";
import Layout from "@/components/layout/index.vue";
import NewDetails from "../views/NewDetails/index";
import ClickFree from "../views/ClickFree/index";
// import NoticeDetail from "../views/Notice/detail";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "/",
    component: Layout,
    redirect: '/home',
    children:[
        {
          path: "/home",
          name: "Home",
          component: Home,
        },
        {
          path: "/productCenter",
          name: "productCenter",
          component: ProductCenter,
        },
        {
          path: "/newsUpdates",
          name: "newsUpdates",
          component: NewsUpdates,
        },
        {
          path: "/customer",
          name: "Customer",
          component: Customer,
        },
        {
          path: "/setPrice",
          name: "setPrice",
          component: SetPrice,
        },
        {
          path: "/contactUs",
          name: "contactUs",
          component: ContactUs,
        },
        {
          path: "/newdetails/:preInfoId",
          name: "newdetails",
          component: NewDetails,
        },
    ]
  },
  {
    path: "/freeTrial",
    name: "freeTrial",
    component: FreeTrial,
  },
   {
    path: "/clickFree",
    name: "clickFree",
    component: ClickFree,
  },
];

export const asyncRouterMap = routes;

const originaPlush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originaPlush.call(this, location).catch((err) => err);
};

const router = new VueRouter({
  mode: 'history',
  // mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

export default router;
